/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftBookMutationRequest, PostApiBarberShiftBookMutationResponse, PostApiBarberShiftBook400, PostApiBarberShiftBook401, PostApiBarberShiftBook403, PostApiBarberShiftBook404, PostApiBarberShiftBook500 } from "../entities/PostApiBarberShiftBook";

function getPostApiBarberShiftBookUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/book` as const }
  return res
}

/**
 * @description Забронировать смену на сегодня/завтра
 * @summary Забронировать смену
 * {@link /api/barber/shift/book}
 */
export async function postApiBarberShiftBook(data: PostApiBarberShiftBookMutationRequest, config: Partial<RequestConfig<PostApiBarberShiftBookMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberShiftBookMutationResponse, ResponseErrorConfig<PostApiBarberShiftBook400 | PostApiBarberShiftBook401 | PostApiBarberShiftBook403 | PostApiBarberShiftBook404 | PostApiBarberShiftBook500>, PostApiBarberShiftBookMutationRequest>({ method : "POST", url : getPostApiBarberShiftBookUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}